/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import Button from "@mui/material/Button";
import * as messagesActions from "../../store/messages/actions";
import { useCustomer } from "../../provider/Customer/CustomerProvider";
import { Box } from "@mui/material";
import { apiGet } from "../../services/apiClient";
import ProductBox from "@/src/components/ProductBox/ProductBox";
import ProductBoxGrid from "@/src/components/ProductBoxGrid/ProductBoxGrid";

export default function AccountPassword() {
  const { customer } = useCustomer();
  const [isPasswordRecovered, setIsPasswordRecovered] = useState(false);

  if (!customer) {
    return null;
  }

  const handleReset = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    try {
      await apiGet("/customers/password_reset", { email: customer.email.toLowerCase() });
      messagesActions.addMessage({
        type: "success",
        text: "Wir haben Ihnen eine E-Mail zum Ändern Ihres Passworts geschickt.",
      });
      setIsPasswordRecovered(true);
    } catch (e) {
      messagesActions.addMessage({
        type: "error",
        text: "Es ist ein Fehler beim verschicken der Daten aufgetreten!",
      });
    }
  };

  return (
    <ProductBox headline={"Passwort ändern"}>
      <ProductBoxGrid
        items={[
          <Box>Fordern Sie hier ganz einfach eine E-Mail an, um ein neues Passwort zu setzen.</Box>,
          <Button fullWidth variant={"outlined"} onClick={handleReset} disabled={isPasswordRecovered}>
            {isPasswordRecovered ? "E-Mail wurde verschickt" : "E-Mail anfordern"}
          </Button>,
        ]}
      />
    </ProductBox>
  );
}
